/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_BodyInputs */

const en_road_dude_prompt_body = /** @type {(inputs: Road_Dude_Prompt_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a character to get an English prompt with the setting, camera angle, gestures and dialogue already written. Take it straight to the video generator or copy it into your own workflow.`)
};

const zh_road_dude_prompt_body = /** @type {(inputs: Road_Dude_Prompt_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择角色即可获得英文提示词，场景、镜头、动作和对白都已写好。可以直接带入站内生成器，也可以复制到自己的创作工具。`)
};

/**
* | output |
* | --- |
* | "Choose a character to get an English prompt with the setting, camera angle, gestures and dialogue already written. Take it straight to the video generator or..." |
*
* @param {Road_Dude_Prompt_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_body = /** @type {((inputs?: Road_Dude_Prompt_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_body(inputs)
	return zh_road_dude_prompt_body(inputs)
});
export { road_dude_prompt_body as "road_dude.prompt.body" }